"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _taggedTemplateLiteralLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteralLoose"));

var _react = _interopRequireWildcard(require("react"));

var _reactRedux = require("react-redux");

var _reactDom = require("react-dom");

var _propTypes = _interopRequireDefault(require("prop-types"));

var CustomPropTypes = _interopRequireWildcard(require("../../constants/PropTypes"));

var _classnames = _interopRequireDefault(require("classnames"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _colors = require("HubStyleTokens/colors");

var _misc = require("HubStyleTokens/misc");

var _sizes = require("HubStyleTokens/sizes");

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _unescapedText = _interopRequireDefault(require("I18n/utils/unescapedText"));

var _Big = _interopRequireDefault(require("UIComponents/elements/Big"));

var _Small = _interopRequireDefault(require("UIComponents/elements/Small"));

var _H = _interopRequireDefault(require("UIComponents/elements/headings/H1"));

var _H2 = _interopRequireDefault(require("UIComponents/elements/headings/H2"));

var _UIButton = _interopRequireDefault(require("UIComponents/button/UIButton"));

var _UILink = _interopRequireDefault(require("UIComponents/link/UILink"));

var _UIIcon = _interopRequireDefault(require("UIComponents/icon/UIIcon"));

var _UIImage = _interopRequireDefault(require("UIComponents/image/UIImage"));

var _UIFlex = _interopRequireDefault(require("UIComponents/layout/UIFlex"));

var _UIMediaObject = _interopRequireDefault(require("UIComponents/layout/UIMediaObject"));

var _UIBreadcrumbs = _interopRequireDefault(require("UIComponents/nav/UIBreadcrumbs"));

var _UITab = _interopRequireDefault(require("UIComponents/nav/UITab"));

var _UITabs = _interopRequireDefault(require("UIComponents/nav/UITabs"));

var _UITooltip = _interopRequireDefault(require("UIComponents/tooltip/UITooltip"));

var _UIRouterLink = _interopRequireDefault(require("ui-addon-react-router-dom/UIRouterLink"));

var CategorySlug = _interopRequireWildcard(require("ecosystem-marketplace-core/constants/urlSlugs/CategorySlug"));

var SuperCategorySlug = _interopRequireWildcard(require("ecosystem-marketplace-core/constants/urlSlugs/SuperCategorySlug"));

var _UIResponsiveComponent = _interopRequireDefault(require("ecosystem-marketplace-core/components/UIResponsiveComponent"));

var _Rating = _interopRequireDefault(require("ecosystem-marketplace-core/components/reviews/Rating"));

var _useWindowDimensionsContext = require("ecosystem-marketplace-core/hooks/useWindowDimensionsContext");

var _i18n = require("ecosystem-marketplace-core/utils/i18n");

var _requestIdleCallback = require("ecosystem-marketplace-core/utils/requestIdleCallback");

var _constants = require("../../constants");

var _urls = require("../../utils/urls");

var _PieSyncConnectorIcon = _interopRequireDefault(require("../common/PieSyncConnectorIcon"));

var _ConnectButton = _interopRequireDefault(require("./connect/ConnectButton"));

var _auth = require("../../selectors/auth");

function _templateObject() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  .app-detail__header__inner {\n    display: flex;\n    flex-direction: row;\n    align-items: stretch;\n  }\n\n  .app-detail__header__icon {\n    flex: 0 0 auto;\n    order: 1;\n    margin-right: ", "px;\n    width: ", "px;\n  }\n\n  .app-detail__header__heading {\n    flex: 1 1;\n    order: 2;\n  }\n\n  .app-detail__header__buttons {\n    flex: 0 0 auto;\n    order: 3;\n  }\n\n  .app-detail__header__tabs {\n    flex: 1 1 100%;\n    order: 4;\n    align-self: auto;\n    padding-top: ", "px;\n  }\n\n  &.is--sticky {\n    .app-detail__header__inner {\n      position: fixed;\n      top: 0;\n      left: 0;\n      z-index: ", ";\n      padding: 0 ", "px;\n      width: 100%;\n      height: ", "px;\n      background-color: ", ";\n      border-bottom: 1px solid ", ";\n      box-shadow: ", ";\n\n      &__flex {\n        margin: 0 auto;\n        width: 100%;\n        max-width: ", "px;\n      }\n    }\n\n    .app-detail__header__icon {\n      width: ", "px;\n    }\n\n    .app-detail__header__tabs {\n      flex-basis: auto;\n      order: 2;\n      align-self: flex-end;\n    }\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var GRID_BREAKPOINT_MEDIUM_INT = parseInt(_sizes.GRID_BREAKPOINT_MEDIUM, 10);
var GRID_BREAKPOINT_LARGE_INT = parseInt(_sizes.GRID_BREAKPOINT_LARGE, 10);
var ICON_GUTTER = 20;
var ICON_SIZE = _constants.DEFAULT_ICON_SIZE;
var STICKY_ICON_SIZE = _constants.SMALL_ICON_SIZE;
var ICON_SIZE_DIFF = _constants.DEFAULT_ICON_SIZE - STICKY_ICON_SIZE;
var STICKY_HEADER_HEIGHT = 60;
var TAB_INDICATOR_HEIGHT_INT = parseInt(_sizes.TAB_INDICATOR_HEIGHT, 10);
var TABS_PADDING_TOP = 12;
var textPath = 'appMarketplace.detail.header';

var Wrapper = _styledComponents.default.div.withConfig({
  displayName: "Header__Wrapper",
  componentId: "sc-1va16cz-0"
})(_templateObject(), ICON_GUTTER, ICON_SIZE, TABS_PADDING_TOP, _sizes.MARS_LAYER, _constants.MAIN_SECTION_PADDING_X / 2, STICKY_HEADER_HEIGHT, _colors.GYPSUM, _colors.BATTLESHIP, _misc.TOOLTIP_SHADOW, _constants.MAIN_SECTION_MAX_WIDTH, STICKY_ICON_SIZE);

var getOffsetTop = function getOffsetTop(el) {
  if (!el) {
    return 0;
  }

  return getOffsetTop(el.offsetParent) + el.offsetTop;
};

var Header = function Header(_ref) {
  var activeTab = _ref.activeTab,
      appId = _ref.appId,
      appName = _ref.appName,
      appUrl = _ref.appUrl,
      breadcrumbs = _ref.breadcrumbs,
      category = _ref.category,
      certifiedAt = _ref.certifiedAt,
      connectionType = _ref.connectionType,
      headingLevel = _ref.headingLevel,
      iconUrl = _ref.iconUrl,
      installability = _ref.installability,
      isPieSyncConnector = _ref.isPieSyncConnector,
      isPreview = _ref.isPreview,
      listingId = _ref.listingId,
      onConnectButtonClick = _ref.onConnectButtonClick,
      onTrackInteraction = _ref.onTrackInteraction,
      reviewSummary = _ref.reviewSummary,
      showTabs = _ref.showTabs,
      showConnectButton = _ref.showConnectButton,
      showSetUpUrl = _ref.showSetUpUrl,
      setActiveTab = _ref.setActiveTab,
      setTabClicked = _ref.setTabClicked,
      setupUrl = _ref.setupUrl,
      slug = _ref.slug,
      superCategory = _ref.superCategory,
      tagline = _ref.tagline,
      isCustomer = _ref.isCustomer,
      wrapperStyle = _ref.wrapperStyle;

  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      sticky = _useState2[0],
      setSticky = _useState2[1];

  var _useState3 = (0, _react.useState)(null),
      _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
      stickyOffsetTop = _useState4[0],
      setStickyOffsetTop = _useState4[1];

  var _useState5 = (0, _react.useState)(null),
      _useState6 = (0, _slicedToArray2.default)(_useState5, 2),
      headerHeight = _useState6[0],
      setHeaderHeight = _useState6[1];

  var headerWrapperRef = (0, _react.createRef)();
  var breadcrumbsWrapperRef = (0, _react.createRef)();
  var headingWrapperRef = (0, _react.createRef)();
  var iconWrapperRef = (0, _react.createRef)();
  var tabsWrapperRef = (0, _react.createRef)();
  var categorySlug = CategorySlug[category];
  var superCategorySlug = SuperCategorySlug[superCategory];
  var isPublic = (0, _reactRedux.useSelector)(_auth.getIsPublic);

  var _useWindowDimensionsC = (0, _useWindowDimensionsContext.useWindowDimensionsContext)(),
      windowWidth = _useWindowDimensionsC.width;

  var isScreenLargeOrSmaller = windowWidth <= GRID_BREAKPOINT_LARGE_INT;
  var isScreenMediumOrLarger = windowWidth >= GRID_BREAKPOINT_MEDIUM_INT;
  var tabClasses = (0, _classnames.default)({
    'p-x-3': sticky && isScreenLargeOrSmaller
  });
  var renderedConnectButton = (0, _react.useMemo)(function () {
    return isPreview ? _react.default.createElement(_UIButton.default, {
      use: "primary",
      disabled: true
    }, _react.default.createElement(_FormattedMessage.default, {
      message: textPath + ".connectAppButton.text"
    })) : _react.default.createElement(_ConnectButton.default, {
      appId: appId,
      appName: appName,
      appUrl: appUrl,
      connectionType: connectionType,
      installability: installability,
      isCustomer: isCustomer,
      listingId: listingId,
      onConnectButtonClick: onConnectButtonClick,
      onTrackInteraction: onTrackInteraction,
      sticky: sticky
    });
  }, [appId, appName, appUrl, connectionType, installability, isCustomer, isPreview, listingId, onConnectButtonClick, onTrackInteraction, sticky]);
  var trackBreadcrumbLinkClick = (0, _react.useCallback)(function (value) {
    onTrackInteraction('click breadcrumb link', 'header', value);
  }, [onTrackInteraction]);
  var trackTabClick = (0, _react.useCallback)(function (tabId) {
    onTrackInteraction('click tab navigation', 'header', tabId);
  }, [onTrackInteraction]);
  var setBreadcrumbsScrollState = (0, _react.useCallback)(function (scrollPercent) {
    var breadcrumbsWrapper = breadcrumbsWrapperRef.current;

    if (breadcrumbsWrapper) {
      breadcrumbsWrapper.style.opacity = 1 - scrollPercent;
    }
  }, [breadcrumbsWrapperRef]);
  var setHeadingScrollState = (0, _react.useCallback)(function (scrollPercent) {
    var headingWrapper = headingWrapperRef.current;

    if (headingWrapper) {
      headingWrapper.style.opacity = 1 - scrollPercent;
    }
  }, [headingWrapperRef]);
  var setIconWrapperScrollState = (0, _react.useCallback)(function (scrollPercent) {
    var iconWrapper = iconWrapperRef.current;

    if (iconWrapper) {
      var isAnimating = scrollPercent > 0 && scrollPercent < 1;
      var iconScrollSize = _constants.DEFAULT_ICON_SIZE - ICON_SIZE_DIFF * scrollPercent;
      iconWrapper.style.position = isAnimating ? 'relative' : '';
      iconWrapper.style.top = isAnimating ? _constants.DEFAULT_ICON_SIZE - iconScrollSize + scrollPercent * TABS_PADDING_TOP + "px" : '';
      iconWrapper.style.marginRight = isAnimating ? _constants.DEFAULT_ICON_SIZE - iconScrollSize + ICON_GUTTER + "px" : '';
      iconWrapper.style.width = isAnimating ? iconScrollSize + "px" : '';
    }
  }, [iconWrapperRef]);
  var setTabsWrapperScrollState = (0, _react.useCallback)(function (scrollPercent) {
    var tabsWrapper = tabsWrapperRef.current;

    if (tabsWrapper) {
      tabsWrapper.style.transform = scrollPercent < 1 ? "translateX(" + (STICKY_ICON_SIZE + ICON_GUTTER) * scrollPercent + "px)" : '';
    }
  }, [tabsWrapperRef]);
  var defaultBreadcrumbs = (0, _react.useMemo)(function () {
    return !isPreview ? _react.default.createElement(_UIBreadcrumbs.default, {
      className: "m-top-0",
      flush: true
    }, _react.default.createElement(_UIRouterLink.default, {
      onClick: function onClick() {
        return trackBreadcrumbLinkClick('all apps');
      },
      to: "/"
    }, _react.default.createElement(_FormattedMessage.default, {
      message: textPath + ".rootBreadcrumbLinkText"
    })), superCategory && _react.default.createElement(_UIRouterLink.default, {
      onClick: function onClick() {
        return trackBreadcrumbLinkClick(superCategory);
      },
      to: "/" + superCategorySlug
    }, _react.default.createElement(_FormattedMessage.default, {
      message: (0, _i18n.getSuperCategoryI18nKey)(superCategory)
    })), category && _react.default.createElement(_UIRouterLink.default, {
      onClick: function onClick() {
        return trackBreadcrumbLinkClick(category);
      },
      to: "/" + superCategorySlug + "/" + categorySlug
    }, _react.default.createElement(_FormattedMessage.default, {
      message: (0, _i18n.getCategoryI18nKey)(category)
    })), _react.default.createElement("span", null, appName)) : null;
  }, [appName, category, categorySlug, isPreview, superCategory, superCategorySlug, trackBreadcrumbLinkClick]);
  var renderedCertifiedLabel = (0, _react.useMemo)(function () {
    return certifiedAt ? _react.default.createElement(_UITooltip.default, {
      placement: "bottom",
      title: (0, _unescapedText.default)(textPath + ".certifiedLabel.tooltip")
    }, _react.default.createElement("div", {
      style: {
        display: 'inline-block',
        lineHeight: 1
      }
    }, _react.default.createElement(_UIIcon.default, {
      className: "m-right-1",
      color: _colors.LORAX,
      name: "hubspotCertification",
      size: 24,
      style: {
        position: 'relative',
        top: 2
      }
    }), _react.default.createElement(_Small.default, {
      style: {
        fontWeight: 600,
        textTransform: 'uppercase'
      }
    }, _react.default.createElement(_FormattedMessage.default, {
      message: textPath + ".certifiedLabel.text"
    })))) : null;
  }, [certifiedAt]);
  var renderedReviewSummary = (0, _react.useMemo)(function () {
    if (reviewSummary && reviewSummary.reviewCount) {
      return _react.default.createElement("div", {
        className: "m-top-2"
      }, _react.default.createElement(_Rating.default, {
        rating: reviewSummary.overallRating,
        label: _react.default.createElement(_UILink.default, {
          disabled: isPreview,
          href: (0, _urls.getAllReviewsUrl)(isPublic, slug, category)
        }, _react.default.createElement(_FormattedMessage.default, {
          message: textPath + ".reviewCount",
          options: {
            count: reviewSummary.reviewCount
          }
        })),
        iconSize: "xxs"
      }));
    }

    return null;
  }, [category, isPreview, isPublic, reviewSummary, slug]);
  var renderedHeading = (0, _react.useMemo)(function () {
    var Heading = headingLevel === 'h2' ? _H2.default : _H.default;
    var headingClasses = (0, _classnames.default)('m-bottom-1', {
      'is--heading-1': headingLevel === 'h2'
    });
    return _react.default.createElement(Heading, {
      className: headingClasses
    }, appName, isPieSyncConnector && _react.default.createElement(_PieSyncConnectorIcon.default, {
      className: "m-left-3"
    }));
  }, [appName, headingLevel, isPieSyncConnector]);
  var scrollAnimationFrame = (0, _react.useCallback)(function () {
    if (!isScreenMediumOrLarger) {
      setSticky(false);
      return;
    }

    var _window = window,
        pageYOffset = _window.pageYOffset;

    var _ref2 = (0, _reactDom.findDOMNode)(headerWrapperRef.current) || {},
        headerOffsetTop = _ref2.offsetTop;

    if (stickyOffsetTop !== null) {
      var scrollPercent;

      if (pageYOffset >= headerOffsetTop && pageYOffset <= stickyOffsetTop) {
        scrollPercent = (pageYOffset - headerOffsetTop) / (stickyOffsetTop - headerOffsetTop);
      } else if (pageYOffset > stickyOffsetTop) {
        scrollPercent = 1;
      } else if (pageYOffset < headerOffsetTop) {
        scrollPercent = 0;
      }

      if (scrollPercent >= 0 && scrollPercent <= 1) {
        setBreadcrumbsScrollState(scrollPercent);
        setHeadingScrollState(scrollPercent);
        setIconWrapperScrollState(scrollPercent);
        setTabsWrapperScrollState(scrollPercent);
      }

      setSticky(scrollPercent === 1);
    }
  }, [isScreenMediumOrLarger, headerWrapperRef, stickyOffsetTop, setBreadcrumbsScrollState, setHeadingScrollState, setIconWrapperScrollState, setTabsWrapperScrollState]);
  (0, _react.useEffect)(function () {
    if (!sticky) {
      var _ref3 = tabsWrapperRef.current || {},
          tabsOffsetTop = _ref3.offsetTop;

      var _ref4 = (0, _reactDom.findDOMNode)(headerWrapperRef.current) || {},
          headerRefHeight = _ref4.offsetHeight;

      setStickyOffsetTop(tabsOffsetTop || null);
      setHeaderHeight(headerRefHeight || null);
      setBreadcrumbsScrollState(0);
      setHeadingScrollState(0);
      setIconWrapperScrollState(0);
      setTabsWrapperScrollState(0);
    }
  }, [setBreadcrumbsScrollState, setHeadingScrollState, sticky, tabsWrapperRef, headerWrapperRef, setHeaderHeight, setIconWrapperScrollState, setTabsWrapperScrollState]);
  (0, _react.useEffect)(function () {
    var scrollHandler = function scrollHandler() {
      window.requestAnimationFrame(scrollAnimationFrame);
    };

    window.addEventListener('scroll', scrollHandler);
    return function () {
      window.removeEventListener('scroll', scrollHandler);
    };
  }, [scrollAnimationFrame]);
  (0, _react.useEffect)(function () {
    scrollAnimationFrame();
  }, [scrollAnimationFrame]);
  var scrollToSection = (0, _react.useCallback)(function (sectionName) {
    var cancelScrollCallback = (0, _requestIdleCallback.requestIdleCallback)(function () {
      var scrollY = getOffsetTop(document.querySelector("#" + sectionName));

      if (scrollY) {
        window.scrollTo({
          top: scrollY - _constants.NAV_BAR_HEIGHT_INT,
          behavior: 'smooth'
        });
      }
    });
    setActiveTab(sectionName);
    setTabClicked(true);
    setTimeout(function () {
      setTabClicked(false);
    }, 1000);
    return function () {
      cancelScrollCallback();
    };
  }, [setActiveTab, setTabClicked]);
  var onTabClick = (0, _react.useCallback)(function (tabName, evt) {
    evt.preventDefault();
    trackTabClick(tabName);
    return scrollToSection(tabName);
  }, [scrollToSection, trackTabClick]);
  (0, _react.useEffect)(function () {
    if (window.location.hash) {
      scrollToSection(window.location.hash.slice(1));
    }
  }, [scrollToSection]);
  return _react.default.createElement(Wrapper, {
    className: (0, _classnames.default)('app-detail__header', 'p-top-4', {
      'is--sticky': sticky
    }),
    style: (0, _extends2.default)({
      // Adjust based on the non-sticky header height, including nav borders
      paddingBottom: sticky ? headerHeight - STICKY_HEADER_HEIGHT - TAB_INDICATOR_HEIGHT_INT : 0
    }, wrapperStyle),
    ref: headerWrapperRef
  }, _react.default.createElement("div", {
    className: "m-bottom-6",
    ref: breadcrumbsWrapperRef
  }, breadcrumbs || defaultBreadcrumbs), _react.default.createElement("div", {
    className: "app-detail__header__inner"
  }, _react.default.createElement(_UIFlex.default, {
    align: "center",
    justify: "between",
    className: "app-detail__header__inner__flex",
    wrap: "wrap"
  }, _react.default.createElement(_UIMediaObject.default, {
    itemLeft: _react.default.createElement("div", {
      className: "app-detail__header__icon",
      ref: iconWrapperRef
    }, _react.default.createElement(_UIImage.default, {
      src: iconUrl
    }))
  }, !sticky && _react.default.createElement("div", {
    className: "app-detail__header__heading",
    ref: headingWrapperRef
  }, renderedHeading, _react.default.createElement("div", {
    className: "m-bottom-1"
  }, _react.default.createElement(_Big.default, null, tagline)), renderedCertifiedLabel, renderedReviewSummary)), _react.default.createElement("div", {
    className: "app-detail__header__buttons",
    style: {
      width: isScreenMediumOrLarger ? 'auto' : '100%',
      marginTop: isScreenMediumOrLarger ? 0 : 16
    }
  }, showSetUpUrl && _react.default.createElement(_UIButton.default, {
    external: true,
    href: (0, _urls.getFormattedUrl)(setupUrl),
    onClick: function onClick() {
      return onTrackInteraction('click view setup guide', 'header');
    },
    size: sticky ? 'small' : 'default',
    use: "transparent"
  }, _react.default.createElement(_FormattedMessage.default, {
    message: textPath + ".viewSetupGuideLinkText"
  })), showConnectButton && renderedConnectButton), showTabs && _react.default.createElement("div", {
    className: "app-detail__header__tabs",
    ref: tabsWrapperRef
  }, _react.default.createElement(_UIResponsiveComponent.default, {
    display: {
      xs: false,
      md: true
    }
  }, _react.default.createElement(_UITabs.default, {
    bordered: false,
    defaultSelected: "overview",
    selected: activeTab
  }, _react.default.createElement(_UITab.default, {
    className: tabClasses,
    onClick: function onClick(evt) {
      return onTabClick('overview', evt);
    },
    tabId: "overview",
    title: (0, _unescapedText.default)(textPath + ".tabTitles.overview")
  }), _react.default.createElement(_UITab.default, {
    className: tabClasses,
    onClick: function onClick(evt) {
      return onTabClick('pricing', evt);
    },
    tabId: "pricing",
    title: (0, _unescapedText.default)(textPath + ".tabTitles.pricing")
  }), _react.default.createElement(_UITab.default, {
    className: tabClasses,
    onClick: function onClick(evt) {
      return onTabClick('data-permissions', evt);
    },
    tabId: "data-permissions",
    title: (0, _unescapedText.default)(textPath + ".tabTitles.dataPermissions")
  }), _react.default.createElement(_UITab.default, {
    className: tabClasses,
    onClick: function onClick(evt) {
      return onTabClick('reviews', evt);
    },
    tabId: "reviews",
    title: (0, _unescapedText.default)(textPath + ".tabTitles.reviews")
  })))))));
};

Header.propTypes = {
  activeTab: _propTypes.default.string,
  appId: _propTypes.default.number,
  appName: _propTypes.default.string,
  appUrl: _propTypes.default.string,
  breadcrumbs: _propTypes.default.node,
  category: CustomPropTypes.category,
  certifiedAt: _propTypes.default.number,
  connectionType: CustomPropTypes.connectionType,
  headingLevel: _propTypes.default.oneOf(['h1', 'h2']),
  iconUrl: _propTypes.default.string.isRequired,
  installability: CustomPropTypes.installability,
  isCustomer: _propTypes.default.bool.isRequired,
  isPieSyncConnector: _propTypes.default.bool.isRequired,
  isPreview: _propTypes.default.bool,
  listingId: _propTypes.default.number,
  onConnectButtonClick: _propTypes.default.func,
  onTrackInteraction: _propTypes.default.func,
  tagline: _propTypes.default.string.isRequired,
  reviewSummary: _propTypes.default.shape({
    overallRating: _propTypes.default.number,
    reviewCount: _propTypes.default.number
  }),
  showTabs: _propTypes.default.bool.isRequired,
  showConnectButton: _propTypes.default.bool.isRequired,
  showSetUpUrl: _propTypes.default.bool.isRequired,
  setActiveTab: _propTypes.default.func,
  setTabClicked: _propTypes.default.func,
  setupUrl: _propTypes.default.string,
  slug: _propTypes.default.string,
  superCategory: CustomPropTypes.superCategory,
  wrapperStyle: _propTypes.default.object
};
Header.defaultProps = {
  headingLevel: 'h1',
  showTabs: true,
  showConnectButton: true,
  showSetUpUrl: true
};
var _default = Header;
exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./js/components/detail/Header.js
// module id = 385
// module chunks = 209 210 211 212